__webpack_require__.p = "/btcCO2emissions/";